export default __webpack_public_path__ + "static/media/background-home.0236bbb8.svg";